import { TRemoteBankingContactsStep } from '../type';
import { ApplicationDocumentPreviewRemoteBankingContacts } from '~/modules/remote-banking-contacts/ApplicationDocumentPreview/ApplicationDocumentPreviewRemoteBankingContacts.tsx';
import { ManagerStep } from '~/modules/remote-banking-contacts/stepForms/ManagerStep.tsx';
import { ResponsiblePersonsStep } from '~/modules/remote-banking-contacts/stepForms/ResponsiblePersonsStep.tsx';

export const RemoteBankingContactsStep = ({
  current,
  onOptionSignature,
  documents,
  handlePreview,
  onManagerSubmit,
  onResponsiblePersonsSubmit,
}: TRemoteBankingContactsStep) => {
  switch (current) {
    case 1:
      return <ManagerStep onSubmit={onManagerSubmit} />;
    case 2:
      return (
        <ApplicationDocumentPreviewRemoteBankingContacts
          documents={documents}
          handlePreview={handlePreview}
          current={current}
          onOptionSignature={onOptionSignature}
        />
      );
    case 3:
      return <ResponsiblePersonsStep onSubmit={onResponsiblePersonsSubmit} />;
    case 4:
      return (
        <ApplicationDocumentPreviewRemoteBankingContacts
          documents={documents}
          handlePreview={handlePreview}
          current={current}
          onOptionSignature={onOptionSignature}
        />
      );
    default:
      return null;
  }
};
